import { useEffect, useState } from "react";
import { getScoreCardInfo } from "../services/api";
import { ResultData } from "../types";

interface UseResultArgs {
    id?: string;
    token?: string;
    index?: string;
}

export function useResult({ id, token, index }: UseResultArgs) {
    const [data, setData] = useState<ResultData | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!id || !token || !index) {
            setLoading(false);
            setError("Missing required parameters in URL");
            return;
        }

        const controller = new AbortController();
        setLoading(true);
        setError(null);

        getScoreCardInfo({ id, token, index }, controller.signal)
            .then(setData)
            .catch((err: unknown) => {
                if ((err as Error)?.name === "AbortError") return;
                setError(
                    err instanceof Error ? err.message : "Failed to load result"
                );
            })
            .finally(() => setLoading(false));

        return () => controller.abort();
    }, [id, token, index]);

    return { data, loading, error };
}